import { Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { setSchoolLevel } from '../../../../../../redux/reducers/talentSlice'
import * as s from './SchoolLevel.styles'

const { Option } = Select

const levels = (t) => ({
  2: t('common:bac2'),
  3: t('common:bac3'),
  4: t('common:bac4'),
  5: t('common:bac5'),
  above: t('common:bacAbove'),
})

const SchoolLevel = () => {
  const { t } = useTranslation(['common'], { useSuspense: false })
  const dispatch = useDispatch()
  const { schoolLevel } = useSelector((state) => state.talent)

  const handleOnChange = (value) => {
    dispatch(setSchoolLevel(value))
  }
  return (
    <s.SchoolLevelWrapper>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className="field-label">{t('common:table.schoolLevel')}</label>
      <Select
        onChange={handleOnChange}
        placeholder="Select your school level"
        defaultValue={schoolLevel}
      >
        {Object.entries(levels(t)).map((level) => (
          <Option key={level[0]} value={level[0]}>
            {level[1]}
          </Option>
        ))}
      </Select>
    </s.SchoolLevelWrapper>
  )
}

export default SchoolLevel
